import Input from "../../../design/Input";
import './ContactOption.css';



export default ({data, setData}) => {  
    const handleSelectChange = (event) => {
        setData('select', event.target.value);
    }

    return (
        <div className="ContactOption">
            <select onChange={handleSelectChange} value={data.select} >
                <option value={'פלאפון'}>פלאפון</option>
                <option value={'טלפון בית'}> טלפון בית </option>
                <option value={'אמייל'}> אמייל </option>
                <option value={'פקס'}> פקס </option>
            </select>

            <Input 
            type={data.select === 'אמייל' ? 'email' : 'tel'} 
            textView={data.select} 
            myStyle={'input2'} 
            pattern={data.select === 'אמייל' ? 'email' : 'phone'}
            value={data.input}
            onChange={(e) => setData('input', e)}
            />
        </div>
    )
}